import { Component } from '@angular/core';
import { Slide } from '../core/Type/okeeycash-slide.interface';
import { OkeeyCashSliderComponent } from '../okeey-cash-slider/okeey-cash-slider.component';

@Component({
  selector: 'app-journey-okeey-cash',
  templateUrl: './journey-okeey-cash.component.html',
  styleUrl: './journey-okeey-cash.component.scss',
  imports: [OkeeyCashSliderComponent]
})
export class JourneyOkeeyCashComponent {
  public journeySlides: Slide[] = [
    {
      title: 'okeeyCash.journey.applicationJourney',
      subTitleStart: 'okeeyCash.journey.informationMatch',
      descriptionStart: 'okeeyCash.journey.applicationJourneyStart',
      value: 'okeeyCash.journey.applicationJourneyValue',
      link: 'https://secure.attheregister.com/locations',
      descriptionEnd: 'okeeyCash.journey.applicationJourneyEnd',
      img: '/assets/img/my-okeey-cash/journey/application-journey.svg'
    },
    {
      title: 'okeeyCash.journey.okeeyCashCard',
      subTitleStart: 'okeeyCash.journey.okeeyCashCardSubTitleStart',
      subTitleValue: 'okeeyCash.journey.okeeyCashCardSubTitleValue',
      subTitleEnd: 'okeeyCash.journey.okeeyCashCardSubTitleEnd',
      descriptionStart: 'okeeyCash.journey.okeeyCashCardDescriptionStart',
      link: 'https://usa.okeeycash.com/assets/documents/DDAform.pdf',
      value: 'okeeyCash.journey.okeeyCashCardDescriptionValue',
      descriptionEnd: 'okeeyCash.journey.okeeyCashCardDescriptionEnd',
      img: '/assets/img/my-okeey-cash/journey/card.svg'
    },
    {
      title: 'okeeyCash.journey.financialFreedom',
      subTitleStart: 'okeeyCash.journey.financialFreedomSubTitleStart',
      subTitleValue: 'okeeyCash.journey.financialFreedomSubTitleValue',
      subTitleEnd: 'okeeyCash.journey.financialFreedomSubTitleEnd',
      descriptionStart: 'okeeyCash.journey.financialFreedomDescriptionStart',
      link: 'benefit',
      value: 'okeeyCash.journey.financialFreedomDescriptionValue',
      descriptionEnd: 'okeeyCash.journey.financialFreedomDescriptionEnd',
      img: '/assets/img/my-okeey-cash/journey/financial-freedom.svg'
    }
  ];
}
